import { useState } from 'react';
import { Link } from 'react-scroll'
import pdf from "../images/caseyalvarez-resume.pdf";

const NavBar = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <div className="py-3">
      <div className="nav d-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-between align-items-center">
          <Link className="button button-ghost mx-2" activeClass="active" to="about" spy={true} smooth={false} duration={500}>
            about
          </Link>
          <Link className="button button-ghost mx-2" activeClass="active" to="design" spy={true} smooth={false} duration={500}>
            approach
          </Link>
          <Link className="button button-ghost mx-2" activeClass="active" to="contact" spy={true} smooth={false} duration={500}>
            contact
          </Link>
          <a href={pdf}
             target="_blank"
             rel="noopener noreferrer"
             className="button button-primary mx-2">resumé</a>
        </div>
      </div>

      <button
        type="button"
        className={`nav-hamburger ${open ? "is-open" : ""}`}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`nav-overlay ${open ? "is-open" : ""}`}>
        <Link className="nav-overlay-link" activeClass="active" to="about" smooth={false} duration={500} onClick={close}>
          about
        </Link>
        <Link className="nav-overlay-link" activeClass="active" to="design" smooth={false} duration={500} onClick={close}>
          approach
        </Link>
        <Link className="nav-overlay-link" activeClass="active" to="contact" smooth={false} duration={500} onClick={close}>
          contact
        </Link>
        <a href={pdf}
           target="_blank"
           rel="noopener noreferrer"
           className="nav-overlay-link"
           onClick={close}>resumé</a>
      </div>
    </div>
  )
}

export default NavBar;
